(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["matara-home-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialise = (carousel) => {
      if (carousel.dataset.initialised === 'true') return;
      carousel.dataset.initialised = 'true';
      const slides = [...carousel.querySelectorAll('[data-slide]')];
      const dots = [...carousel.querySelectorAll('[data-dot]')];
      const previous = carousel.querySelector('[data-previous]');
      const next = carousel.querySelector('[data-next]');
      const delay = Number(carousel.dataset.delay) || 6000;
      let active = 0;
      let timer;

      const show = (index) => {
        active = (index + slides.length) % slides.length;
        slides.forEach((slide, position) => {
          const selected = position === active;
          slide.classList.toggle('is-active', selected);
          slide.setAttribute('aria-hidden', selected ? 'false' : 'true');
        });
        dots.forEach((dot, position) => {
          const selected = position === active;
          dot.classList.toggle('is-active', selected);
          dot.setAttribute('aria-selected', selected ? 'true' : 'false');
        });
      };

      const stop = () => window.clearInterval(timer);
      const start = () => {
        stop();
        if (slides.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          timer = window.setInterval(() => show(active + 1), delay);
        }
      };

      previous?.addEventListener('click', () => { show(active - 1); start(); });
      next?.addEventListener('click', () => { show(active + 1); start(); });
      dots.forEach((dot) => dot.addEventListener('click', () => { show(Number(dot.dataset.dot)); start(); }));
      carousel.addEventListener('mouseenter', stop);
      carousel.addEventListener('mouseleave', start);
      carousel.addEventListener('focusin', stop);
      carousel.addEventListener('focusout', start);
      start();
    };

    document.querySelectorAll('[data-matara-carousel]').forEach(initialise);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-matara-carousel]').forEach(initialise);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
